import { useState } from "react";
import { Form } from "react-bootstrap";
import { EyeSvg } from "../../svgFiles/EyeSvg";
import "./PasswordInput.css";

export function isValidLoginPassword(password) {
  const value = String(password || "");
  if (value.length < 8 || value.length > 50) return false;
  if (!/[A-Z]/.test(value)) return false;
  if (!/[a-z]/.test(value)) return false;
  if (!/\d/.test(value)) return false;
  if (!/\W/.test(value)) return false;
  return true;
}

export default function PasswordInput({
  name,
  value,
  onChange,
  placeholder,
  error = false,
  autoComplete = "new-password",
  className = "",
}) {
  const [visible, setVisible] = useState(false);

  return (
    <div className={`va-password-input ${className}`.trim()}>
      <Form.Control
        type={visible ? "text" : "password"}
        name={name}
        autoComplete={autoComplete}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`cmn_input va-field__input${
          error ? " va-field__input--error" : ""
        }`}
      />
      <button
        type="button"
        className="va-password-input__toggle"
        onClick={() => setVisible((prev) => !prev)}
        aria-label={visible ? "Hide password" : "Show password"}
      >
        <EyeSvg open={visible} />
      </button>
    </div>
  );
}
